import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import {
  AvailabilityQueryDto,
  CatalogAvailabilityDto,
} from '@/features/dashboard/availability/types/AvailabilityDto.ts';

const availabilityApi = {
  /** POST, a nie GET, bo pytaniem jest lista par (rodzaj, id). */
  getAvailability: async (
    query: AvailabilityQueryDto,
  ): Promise<CatalogAvailabilityDto[]> => {
    return await fetchPrivateApi<CatalogAvailabilityDto[]>(
      'POST',
      `availability`,
      query,
    );
  },
};

export default availabilityApi;
